import styled from "styled-components";
import { Link } from "react-router-dom";

export const CardHolder = styled.div`
  margin-top: 100px;
  display: flex;
  justify-content: center;
  min-width: 70%;
  max-width: 95%;
  height: 70%;
  flex-flow: wrap;
`;
export const Card = styled.div`
  display: flex;
  margin: 30px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 550px;
  height: 400px;
  border-radius: 30px;
  box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(12px);
  background-color: rgba(220, 220, 220, 0.7);
  color: #111;
`;
export const CardDescription = styled.p`
  font-size: 22px;
  margin-bottom: 15px;
`;
export const CardLink = styled.a`
  color: #111;
  font-size: 17px;
`;
export const InnerCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const BottomCardContainer = styled.div`
  display: flex;
`;
export const MainCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 85%;
  height: 85%;
`;
export const MetadataContainer = styled.div`
  display: flex;
`;
export const Author = styled.p`
  font-size: 15px;
`;
export const Time = styled.p`
  font-size: 15px;
  margin-left: 5px;
`;
export const SupportButton = styled(Link)`
  font-size: 15px;
  font-weight: 800;
  margin-right: 10px;
  color: #111;
`;
